import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import IntegrationPanelContainer from "./IntegrationPanelContainer";
import { getAccountState } from "../../../../redux/slices/accountSlice";
import { onCreatorPanelNavigatePath } from "../../../../utils/navigationUtils";
import { NavigationId } from "../../../../navigation/AppParamList";
import { CreatorSettingsTab } from "../../../../screens/Profile/CreatorPanels/CreatorSettingsPanel";
import { Colors } from "../../../../utils/colors";

export const MarkitApiPanelSection = () => {
  const { accountData } = useSelector(getAccountState).account;
  const navigate = useNavigate();

  const onActionPress = useCallback(
    () =>
      onCreatorPanelNavigatePath(
        navigate,
        NavigationId.HOME_SETTINGS,
        CreatorSettingsTab.API
      ),
    [navigate]
  );

  return (
    <IntegrationPanelContainer
      isConnected={false}
      connectedContent={null}
      title="Markit API"
      description="Build your own integrations with Markit's API and webhooks."
      actionLabel={accountData.hasApiKey ? "Manage" : "Set Up"}
      onActionPress={onActionPress}
      icon={<Icon icon="ion:code-slash" height={80} color={Colors.BLACK} />}
    />
  );
};
